export enum StatisticType {
    LOHNAUSWEIS_ERSTELLT = "LOHNAUSWEIS_ERSTELLT",
    LOHNAUSWEIS_ABGESCHLOSSEN = "LOHNAUSWEIS_ABGESCHLOSSEN",
    // ...
}
